var React = require('react');

function KeypadEmergency (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.6 3.158H6.4v-1.58h3.2v1.58zm4.8 0c.88 0 1.6.703 1.6 1.579v8.684A1.59 1.59 0 0 1 14.4 15H1.6A1.59 1.59 0 0 1 0 13.421V4.737c0-.876.712-1.58 1.6-1.58h3.2V1.58L6.4 0h3.2l1.6 1.579v1.579h3.2zM1.6 4.737v8.684h12.8V4.737H1.6zm9.6 5.107H8.8v2.368H7.2V9.844H4.8v-1.58h2.4V5.897h1.6v2.369h2.4v1.579z","fill":"currentColor","fillRule":"evenodd"}));
}

KeypadEmergency.defaultProps = {"width":"16","height":"15","viewBox":"0 0 16 15"};

module.exports = KeypadEmergency;

KeypadEmergency.default = KeypadEmergency;
